import React, { useReducer } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import qs from 'querystringify';
import { withRouter } from 'react-router-dom';

import { MdClose } from 'react-icons/md';

import { Input, ReactDateTimePicker } from '../../../components/elements';
import LocationSuggestion from '../../../components/global/LocationSuggestion';

const Container = styled.form`
  &&& {
    .modal-background {
      background-color: rgba(13, 13, 13, 0.28);
    }
    .modal-card-body {
      height: 100vh;
      padding: 0px;
    }
    .modal-card {
      max-height: calc(100vh - 0px);
      position: absolute;
      right: 0;
      width: 35rem;
    }
    .modal-card-head,
    .modal-card-foot {
      border-top-left-radius: 0px;
      border-top-right-radius: 0px;
    }
    .modal-card-title {
      font-size: 1.5rem;
      font-weight: 600;
    }
    .modal-card-head {
      justify-content: center;
      border-bottom: 0px;
      padding: 1rem 2rem;
      padding-top: 1.5rem;
      background: white;
    }
    .modal-card-foot {
      justify-content: center;
      background: white;
      border-top: 0px;
      .button {
        font-weight: 600;
      }
    }
    .full-width {
      width: 100%;
    }
  }
`;

const MobileContainer = styled.form`
  &&& {
    .modal-background {
      background-color: rgba(13, 13, 13, 0.28);
    }
    .modal-card-body {
      padding: 0px;
    }
    .modal-card {
      width: 100vw;
      height: 100vh;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
    }
    .modal-card-head,
    .modal-card-foot {
      border-top-left-radius: 0px;
      border-top-right-radius: 0px;
    }
    .modal-card-title {
      font-size: 1.5rem;
      font-weight: 600;
    }
    .modal-card-head {
      justify-content: center;
      border-bottom: 0px;
      padding: 1rem 2rem;
      padding-top: 1.5rem;
      background: white;
    }
    .modal-card-foot {
      justify-content: center;
      background: white;
      border-top: 0px;
      .button {
        font-weight: 600;
      }
    }
    .full-width {
      width: 100%;
    }
  }
`;

const CloseButtonWrapper = styled.div`
  position: absolute;
  left: 1rem;
  top: 1.2rem;
  cursor: pointer;
`;

const HeaderContent = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

const BoxWrapper = styled.nav`
  &&& {
    background: #f6f6f6;
  }
`;

const initialState = {
  placeName: '',
  city: '',
  from: null,
  to: null,
  orderNumber: '',
};

function reducer(state, action) {
  switch (action.type) {
    case 'SET_FIELD':
      return { ...state, [action.field]: action.value };
    case 'RESET':
      return initialState;
    default:
      return state;
  }
}

const Search = ({ state, dispatch, searchByOrderNumber }) => {
  const setDateHours = dateObject => {
    dateObject.setHours(0, 0, 0, 0);
    return dateObject;
  };

  const startDateISOString = dateObject =>
    setDateHours(dateObject).toISOString();

  if (searchByOrderNumber) {
    return (
      <BoxWrapper className="box">
        <div className="columns">
          <div className="column is-4">
            <Input
              label="Order Number"
              type="text"
              value={state.orderNumber}
              placeholder="Start entering an Order Number..."
              onChange={event =>
                dispatch({
                  type: 'SET_FIELD',
                  field: 'orderNumber',
                  value: event.target.value?.toUpperCase?.(),
                })
              }
            />
          </div>
        </div>
      </BoxWrapper>
    );
  }

  return (
    <BoxWrapper className="box">
      <div className="columns">
        <div className="column is-4">
          <Input
            label="Place Name"
            type="text"
            value={state.placeName}
            placeholder="Start entering place name..."
            onChange={event =>
              dispatch({
                type: 'SET_FIELD',
                field: 'placeName',
                value: event.target.value,
              })
            }
          />
        </div>
        <div className="column is-3">
          <div className="field">
            <label className="label">City / Suburb</label>
            <div className="control">
              <LocationSuggestion
                initialValue={state.city}
                onSelect={value =>
                  dispatch({
                    type: 'SET_FIELD',
                    field: 'city',
                    value: value.name,
                  })
                }
                onHandleClear={() =>
                  dispatch({ type: 'SET_FIELD', field: 'city', value: '' })
                }
                placeholder="Start entering company name..."
              />
            </div>
          </div>
        </div>
        <>
          <div className="column">
            <ReactDateTimePicker
              value={state.from || startDateISOString(new Date())}
              // maxDate={moment(endDate || moment().toISOString()).toDate()}
              label="From"
              onChange={date => {
                const a = moment(startDateISOString(new Date(date)));
                const b = moment(state.to || moment().toISOString());
                const daysDiff = b.diff(a, 'days');
                if (daysDiff <= 0 || daysDiff > 45) {
                  dispatch({
                    type: 'SET_FIELD',
                    field: 'from',
                    value: startDateISOString(new Date(date)),
                  });
                  dispatch({
                    type: 'SET_FIELD',
                    field: 'to',
                    value: moment(date)
                      .set({
                        hour: 23,
                        minute: 59,
                        second: 0,
                        millisecond: 0,
                      })
                      .toISOString(),
                  });
                } else {
                  dispatch({
                    type: 'SET_FIELD',
                    field: 'from',
                    value: startDateISOString(new Date(date)),
                  });
                }
              }}
              clear={false}
            />
          </div>
          <div className="column">
            <ReactDateTimePicker
              minDate={moment(
                state.from || startDateISOString(new Date()),
              ).toDate()}
              maxDate={moment(state.from || startDateISOString(new Date()))
                .add(45, 'days')
                .toDate()}
              value={state.to || moment().toISOString()}
              label="To"
              onChange={date => {
                dispatch({
                  type: 'SET_FIELD',
                  field: 'to',
                  value: moment(date)
                    .set({
                      hour: 23,
                      minute: 59,
                      second: 0,
                      millisecond: 0,
                    })
                    .toISOString(),
                });
              }}
              clear={false}
            />
          </div>
        </>
      </div>
    </BoxWrapper>
  );
};

function isMobileView() {
  return window?.matchMedia?.('(max-width: 768px)').matches || false;
}

const FormLayout = ({ children, isActive }) => {
  const isMobile = isMobileView();

  if (isMobile) {
    return (
      <MobileContainer
        className={`modal ${isActive && 'is-active'}`}
        onSubmit={e => {
          e.preventDefault();
        }}
      >
        {children}
      </MobileContainer>
    );
  }

  return (
    <Container
      className={`modal ${isActive && 'is-active'}`}
      onSubmit={e => {
        e.preventDefault();
      }}
    >
      {children}
    </Container>
  );
};

const startDateISOString = () => {
  const dateObject = new Date();
  dateObject.setHours(0, 0, 0, 0);
  return dateObject.toISOString();
};

const endDateISOString = () => {
  const dateObject = new Date();
  dateObject.setHours(23, 59, 59, 999);
  return dateObject.toISOString();
};

const ResponsiveSearchForm = ({
  //   children,
  isActiveResponsiveSearchForm,
  setIsActiveResponsiveSearchForm,
  placeName,
  city,
  startDate,
  endDate,
  history,
  searchByOrderNumber,
  orderNumber,
  setOrderNumber,
}) => {
  const [state, dispatch] = useReducer(reducer, {
    ...initialState,
    placeName: placeName || '',
    city: city || '',
    from: startDate || startDateISOString(),
    to: endDate || endDateISOString(),
    orderNumber: orderNumber || '',
  });

  const handlePush = isReset => {
    if (isReset) {
      history.push(
        `/orders-dashboard${qs.stringify(
          {
            placeName: '',
            city: '',
            from: startDateISOString(),
            to: endDateISOString(),
            orderNumber: '',
            page: 1,
          },
          true,
        )}`,
      );
    } else {
      history.push(
        `/orders-dashboard${qs.stringify(
          {
            ...state,
            page: 1,
          },
          true,
        )}`,
      );
    }
  };

  return (
    <FormLayout isActive={isActiveResponsiveSearchForm}>
      <div className="modal-background" />
      <div className="modal-card">
        <header className="modal-card-head">
          <CloseButtonWrapper>
            <MdClose
              size={30}
              type="button"
              onClick={() => {
                setIsActiveResponsiveSearchForm(false);
              }}
            />
          </CloseButtonWrapper>
          <HeaderContent>
            <p className="modal-card-title is-uppercase">Add Search Filters</p>
          </HeaderContent>
        </header>
        <section className="modal-card-body">
          <Search
            state={state}
            dispatch={dispatch}
            searchByOrderNumber={searchByOrderNumber}
          />
          <div className="is-flex m-2">
            <a
              className="button is-large is-fullwidth is-primary mr-2"
              onClick={() => {
                setIsActiveResponsiveSearchForm(false);
                if (searchByOrderNumber && state?.orderNumber) {
                  setOrderNumber(state.orderNumber);
                } else {
                  handlePush();
                }
              }}
            >
              Add Filters
            </a>
            <a
              className="button is-large is-fullwidth is-primary"
              onClick={() => {
                setIsActiveResponsiveSearchForm(false);
                handlePush(true);
                if (searchByOrderNumber) {
                  setOrderNumber('');
                }
              }}
            >
              Reset Filters
            </a>
          </div>
        </section>
      </div>
    </FormLayout>
  );
};

export default withRouter(ResponsiveSearchForm);
